class ConfigServiceUrls {
    playback = '';
    resumePoints = '';
    concurrency = '';
    precision = '';
    userActions = '';
    userActionsWatched = '';

    constructor() {
        Object.seal(this);
    }
}

export default ConfigServiceUrls;
